// src/services/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyA44YPQftruD31wuVq9fBgu4ae9-85dZ_g",
  authDomain: "quarry-3021c.firebaseapp.com",
  projectId: "quarry-3021c",
  storageBucket: "quarry-3021c.firebasestorage.app",
  messagingSenderId: "121192937743",
  appId: "1:121192937743:web:56c7401d176d4d645fe67a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Enable persistence
setPersistence(auth, browserLocalPersistence)
  .catch((error) => {
    console.error("Auth persistence error:", error);
  });

export const db = getFirestore(app);

export default app;